module.exports = __webpack_public_path__ + "images/peekaboo-ba97056bf60442ba772682d97bdd914e.png";